module.exports = "/_next/static/images/slide11-cae170aeae1ef980b76a95df23968ce7.webp";